"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFakeAssignVerifySubmission = void 0;
const tslib_1 = require("tslib");
const index_1 = require("api/index");
const employee_1 = require("api/parsers/employee");
const helper_1 = require("../../../common/helper");
const helpers_1 = require("../../../documents/hr/assignSubmissionVerifies/helpers");
const useAccountChange_1 = require("src/modules/debuging/hooks/useAccountChange");
const useFakeConditionalAssignSubmission_1 = require("./useFakeConditionalAssignSubmission");
const react_1 = require("react");
const context_1 = require("src/context/context");
const TranslationProvider_1 = require("src/providers/TranslationProvider");
const useAccountStructuralUnit_1 = tslib_1.__importDefault(require("../../../menu/hooks/useAccountStructuralUnit"));
const useFakeAssignVerifySubmission = (props) => {
    const { translate } = (0, TranslationProvider_1.useTranslation)();
    const hook = (0, useFakeConditionalAssignSubmission_1.useFakeConditionalAssignSubmission)({ uid: props.uid });
    const [isCreating, setIsCreating] = (0, react_1.useState)(false);
    const [isCreatingForButtonLoading, setIsCreatingForButtonLoading] = (0, react_1.useState)(false);
    const [isConfirming, setIsConfirming] = (0, react_1.useState)(false);
    const [isConfirmingForButtonLoading, setIsConfirmingForButtonLoading] = (0, react_1.useState)(false);
    const accountHook = (0, useAccountStructuralUnit_1.default)({ user: props.auth.state.data.user });
    const headOfHrStructuralUnit = 'ადამიანური რესურსების მართვის სამსახურის უფროსი';
    const budgetingStructuralUnit = 'ბიუჯეტირებისა და ფინანსური ანალიზის სამსახურის მთავარი სპეციალისტი';
    const headOfHrAccount = props.auth.state.data.user?.accounts.find(el => el.name === headOfHrStructuralUnit);
    const budgetingAccount = props.auth.state.data.user?.accounts.find(el => el.name === budgetingStructuralUnit);
    const useAccountChangeHook = (0, useAccountChange_1.useAccountChange)({ authUser: props.auth.state.data.user });
    const { toast } = (0, context_1.useToastContext)();
    const changeUserOrAccount = async (keyword, account) => {
        if (account && account.id === props.auth.state.data.user?.accountId)
            return null;
        if (account && account.id !== props.auth.state.data.user?.accountId) {
            await accountHook.changeActiveAccount(account);
            await props.auth.getAuthUser();
        }
        else {
            const structuralUnits = await index_1.StructuralUnitsUpgradedApi.getStructuralUnits({ filters: { keyword }, perPage: 30 });
            if (structuralUnits.data && structuralUnits.data.length > 0) {
                const filteredStructuralUnits = structuralUnits.data.filter(el => el.employee);
                const foundStructuralUnit = filteredStructuralUnits.find(el => el.fullName === keyword);
                const acc = await useAccountChangeHook.loginAsEmulateUserForDebug(foundStructuralUnit.user.id);
                if (acc) {
                    const authUserAcc = await useAccountChangeHook.getAuthUserForDebug();
                    if (authUserAcc.data) {
                        await accountHook.changeActiveAccount(authUserAcc.data.accounts.find(el => el.name === keyword));
                        return authUserAcc.data.emulatedBy;
                    }
                }
            }
        }
        return null;
    };
    const createVerifyAssignSubmission = async (buttonLoading = true) => {
        if (buttonLoading)
            setIsCreatingForButtonLoading(true);
        const conditionalAssignSubmission = await hook.sendForVerify(false);
        setIsCreating(true);
        if (conditionalAssignSubmission) {
            const items = await index_1.HumanResourcesSubmissionsApi.getHRAssignSubmissionItems(conditionalAssignSubmission?.id);
            if (items) {
                const itemIds = items.data?.map(el => el.id);
                const submissionVerify = await index_1.HumanResourcesSubmissionsApi.createHRVerify({ items: itemIds });
                if (submissionVerify) {
                    const verifyItems = await index_1.HumanResourcesSubmissionVerifiesApi.getHRAssignSubmissionVerifyFormItems(submissionVerify.data?.id);
                    if (verifyItems && verifyItems.data) {
                        const data = verifyItems.data.map(el => {
                            return {
                                ...el,
                                idCardValidityDate: (0, helper_1.dateToSubtract)(null, null, 5) + ' — ' + (0, helper_1.dateToAdd)(null, null, 5),
                                positionInfos: el.positionInfos.map(position => {
                                    return {
                                        ...position,
                                        positionType: {
                                            id: '1',
                                            label: 'აკადემიური'
                                        },
                                        assignType: employee_1.assignTypeOptions[1]
                                    };
                                })
                            };
                        });
                        const params = (0, helpers_1.transformAssignSubmissionVerifyItemsListParams)(data);
                        const updatedItems = await index_1.HumanResourcesSubmissionVerifiesApi.updateHRAssignSubmissionVerifyItems(submissionVerify.data?.id, params);
                        if (buttonLoading)
                            setIsCreatingForButtonLoading(false);
                        setIsCreating(false);
                        if (updatedItems) {
                            toast.success(translate('hr_verify_successfully_created', 'წარმატებით შეიქმნა დანიშვნის წარდგინების გადამოწმება'));
                            return updatedItems;
                        }
                        else {
                            toast.danger(translate('hr_verify_could_not_create', 'წარმატებით ვერ შეიქმნა დანიშვნის წარდგინების გადამოწმება'));
                            return null;
                        }
                    }
                    else {
                        toast.danger(translate('something_went_wrong', 'მოხდა გაუთვალისწინებელი შეცდომა'));
                        if (buttonLoading)
                            setIsCreatingForButtonLoading(false);
                        setIsCreating(false);
                        return null;
                    }
                }
                else {
                    toast.danger(translate('something_went_wrong', 'მოხდა გაუთვალისწინებელი შეცდომა'));
                    if (buttonLoading)
                        setIsCreatingForButtonLoading(false);
                    setIsCreating(false);
                    return null;
                }
            }
            else {
                toast.danger(translate('something_went_wrong', 'მოხდა გაუთვალისწინებელი შეცდომა'));
                if (buttonLoading)
                    setIsCreatingForButtonLoading(false);
                setIsCreating(false);
                return null;
            }
        }
        else {
            toast.danger(translate('something_went_wrong', 'მოხდა გაუთვალისწინებელი შეცდომა'));
            if (buttonLoading)
                setIsCreatingForButtonLoading(false);
            setIsCreating(false);
            return null;
        }
    };
    const confirmEmployees = async (buttonLoading = true) => {
        if (buttonLoading)
            setIsConfirmingForButtonLoading(true);
        const employees = await createVerifyAssignSubmission(false);
        setIsConfirming(true);
        if (employees?.data) {
            const projectIds = [];
            employees?.data?.forEach(el => {
                return el.positionInfos.forEach(position => {
                    return position.projectInfos.forEach(project => {
                        projectIds.push(project.id);
                    });
                });
            });
            // const emulatedByHrEmployee = await changeUserOrAccount('ადამიანური რესურსების მართვის სამსახურის მთავარი სპეციალისტი', employeeOfHrName, hrEmployeeAccount)
            const confirmedByHrEmployee = await index_1.HumanResourcesSubmissionVerifiesApi.confirmItems({ ids: projectIds });
            // if (emulatedByHrEmployee?.id) await emulateHook.logoutAsEmulateUser(props.auth.user.id, true)
            if (confirmedByHrEmployee.data) {
                toast.success(translate('project(s)_confirm_successfully_hr', 'პროექტ(ებ)ი წარმატებით დადასტურდა ჰრ-ის თანამშრომლის მიერ'));
                const emulatedByBudgetingEmployee = await changeUserOrAccount(budgetingStructuralUnit, budgetingAccount);
                const confirmedByBudgetingEmployee = await index_1.HumanResourcesSubmissionVerifiesApi.confirmItems({ ids: projectIds });
                if (emulatedByBudgetingEmployee?.id)
                    await useAccountChangeHook.logoutAsEmulateUserForDebug(props.auth.state.data.user.id);
                if (confirmedByBudgetingEmployee) {
                    toast.success(translate('project(s)_confirm_successfully_budgeting', 'პროექტ(ებ)ი წარმატებით დადასტურდა საფინანსოს თანამშრომლის მიერ'));
                    const emulatedByHeadOfHr = await changeUserOrAccount(headOfHrStructuralUnit, headOfHrAccount);
                    const confirmedByHeadOfHr = await index_1.HumanResourcesSubmissionVerifiesApi.confirmItems({ ids: projectIds });
                    if (emulatedByHeadOfHr?.id)
                        await useAccountChangeHook.logoutAsEmulateUserForDebug(props.auth.state.data.user.id);
                    if (confirmedByHeadOfHr) {
                        toast.success(translate('project(s)_confirm_successfully_hr_head', 'პროექტ(ებ)ი წარმატებით დადასტურდა ჰრ-ის უფროსის მიერ'));
                    }
                    else {
                        toast.danger(translate('project(s)_confirm_failed_hr_head', 'პროექტ(ებ)ი წარმატებით ვერ დადასტურდა ჰრ-ის უფროსის მიერ'));
                    }
                }
                else {
                    toast.danger(translate('project(s)_confirm_failed_budgeting', 'პროექტ(ებ)ი წარმატებით ვერ დადასტურდა საფინანსოს თანამშრომლის მიერ'));
                }
            }
            else {
                toast.danger(translate('project(s)_confirm_failed_hr', 'პროექტ(ებ)ი წარმატებით ვერ დადასტურდა ჰრ-ის თანამშრომლის მიერ'));
            }
        }
        if (buttonLoading)
            setIsConfirmingForButtonLoading(false);
        setIsConfirming(false);
    };
    return {
        createVerifyAssignSubmission,
        isCreating,
        isCreatingForButtonLoading,
        confirmEmployees,
        isConfirming,
        isConfirmingForButtonLoading
    };
};
exports.useFakeAssignVerifySubmission = useFakeAssignVerifySubmission;
